const target = document.querySelectorAll('.first, .second');
let timeoutId;

function animeScroll() {
    target.forEach(function (element) {
        if (
            element.getBoundingClientRect().top >= 0 &&
            element.getBoundingClientRect().bottom <= (window.innerHeight || document.documentElement.clientHeight)
        ) {
            element.classList.add('animate');
        }
    });
}

animeScroll();

window.addEventListener('scroll', function () {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(function () {
        animeScroll();
    }, 200);
});
